module.exports = __webpack_public_path__ + "static/media/report_2.96e1de96.jpg";